import React from 'react';

/**
 * DashboardHeader hosts optional page actions (search, filters, toolbars).
 * Page titles and descriptive subtitles are omitted — navigation chrome identifies the view.
 */
export interface DashboardHeaderProps {
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
}

export const DashboardHeader: React.FC<DashboardHeaderProps> = ({ children }) => {
  if (!children) {
    return null;
  }

  return (
    <div className="mb-2 md:mb-4 flex flex-col gap-2 md:gap-3">
      <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
        <div className="min-w-0 w-full flex-grow">{children}</div>
      </div>
    </div>
  );
};

export default DashboardHeader;
